{
  "list": {
    "title": "Notifications"
  },
  "planExport": {
    "download": "Télécharger",
    "view": "Afficher",
    "completed": "terminé",
    "failed": "n'a pas pu être terminé",
    "inProgress": "est en cours",
    "export": "exportation",
    "completedStatus": "Terminé",
    "failedStatus": "Échoué",
    "inProgressStatus": "En cours"
  },
  "markAsRead": "Marquer comme lu",
  "noNotifications": "Il n'y a actuellement aucune notification.",
  "layersImport": {
    "in-progress": {
      "title": "Importer des couches",
      "description": "Importation de couches : {{ name }}"
    },
    "completed": {
      "title": "Importation des couches terminée",
      "description": "Importation des couches terminée : {{ name }}"
    },
    "failed": {
      "title": "Impossible d'importer des couches",
      "description": "Impossible d'importer les couches : {{ name }}"
    },
    "goToMap": "Accéder à la carte"
  },
  "layersCopy": {
    "in-progress": {
      "title": "Copier des couches",
      "description": "Copier des couches : {{ name }}"
    },
    "completed": {
      "title": "Copier les couches terminées",
      "description": "Copier les couches terminées"
    },
    "failed": {
      "title": "Impossible de copier les couches",
      "description": "Impossible de copier les couches : {{ name }}"
    },
    "goToMap": "Accéder à la carte"
  },
  "layersUnlink": {
    "in-progress": {
      "title": "Dissocier les couches",
      "description": "Dissocier les couches : {{ name }}"
    },
    "completed": {
      "title": "La dissociation des couches est terminée",
      "description": "La dissociation des couches est terminée"
    },
    "failed": {
      "title": "Impossible de dissocier les couches",
      "description": "Impossible de dissocier les couches : {{ name }}"
    },
    "goToMap": "Accéder à la carte"
  },
  "mapsCopy": {
    "in-progress": {
      "title": "Plan (s) de copie",
      "description": "Copier vers : {{ destinationName }}"
    },
    "completed": {
      "title": "Copier le plan (s) terminé (s)",
      "description": "Copié vers : {{ destinationName }}"
    },
    "goToLocation": "Accédez à {{ destinationName }}",
    "teamMapLimitReached": "La limite des plans d'équipe est atteinte.",
    "somePlansWereNotCopied": "Certains plans n'ont pas été copiés.",
    "somePlansFailedToCopy": "Certains plans n'ont pas pu être copiés."
  }
}